// languages
import en from './en';

const DICTIONARY: Dictionary = {
  en,
};

export default DICTIONARY;
